import { contentApi } from '@/infrastructure/Configuration'

export default class MyAccountService {
  constructor(httpClient) {
    this.httpClient = httpClient
  }

  async getAppleTreeB2bBanner (programType) {
    if (!programType) {
      throw new Error()
    }

    const queryParams = `programType=${programType}`
    const url = `${contentApi}/account/apple-tree-b2b?${queryParams}`

    const { data: response } = await this.httpClient.get(url)

    const appleTreeBannerModule = response?.appleTreeBannerModule

    if (!appleTreeBannerModule || !appleTreeBannerModule?.appleTreeBannerInfo?.length) {
      throw new Error()
    }

    return appleTreeBannerModule.appleTreeBannerInfo[0]
  }
}
